<template>
  <v-layout 
    v-if="getNot.notShow"
    column="">

    <!-- //BANNER -->
    <not-banner v-if="getNot.notType=='images'"
      :not="not"
      :notHeight="getNot.notHeight"
      :notText="getNot.notText"
      :notIndicators="getNot.notIndicators"
      :notImages="getNot.notImages" 
      :notShow="true"/> 

    <!-- //IMAGE -->
    <v-card  v-else-if="getNot.notType=='image'"
      class="pt-10" 
      flat=""
      color="secondary"
      :img="getNot.notImages?getNot.notImages[0].src:''"
      tile=""
      :height="getNot.notHeight">
      <v-container fill-height >
        <v-layout fill-height="" column="" > 
          <v-spacer></v-spacer>
          <v-sheet color="transparent">
            <v-layout align-center="" class="b1--text not-shadow not-zindex-1"> 
              <v-row class="b1--text not-shadow not-zindex-1" >
                <div v-for="(link, index) in links" :key="index">
                  
                    <div class="not-f6 font-weight-bold font-italic white--text" v-if="not.size(links)===index+1">
                      <div v-if="!$route.params.id">
                        {{link}}
                      </div>
                      <div v-else>
                        ...
                      </div>
                    </div>
                    <router-link v-else :to="getLink({name:link,index:index})" class="not-f6 not-line0 font-italic b1--text">
                      {{link===""?"Home":link}}
                      <span class="not-6 font-weight-bold px-1">/</span>
                    </router-link> 
                </div>
                     
              </v-row>
              <v-spacer ></v-spacer>
              <div class="not-f8 font-weight-bold not-zindex-1">{{$route.name}}</div>
            </v-layout>
          </v-sheet>
        </v-layout> 

        <!-- //OVERLAY BACKGROUND COLOR -->
        <v-overlay color="black" absolute="" z-index="1"></v-overlay>

      </v-container>
    </v-card>

    <!-- //MAP -->
    <v-card  v-else-if="getNot.notType=='map'"
      class="pt-10" 
      flat=""
      color="secondary"
      :img="getNot.notImages?getNot.notImages[0].src:''"
      tile=""
      :height="getNot.notHeight">
      <!-- //OVERLAY BACKGROUND COLOR -->
        <v-overlay color="black" absolute="" z-index="1"></v-overlay>
      
      <v-container fill-height>
        <v-layout align-center="" justify-center="" fill-height="" full-width> 
              <not-map-google 
                class="mt-10 not-zindex-1"
                :mp_height="null"
                :mp_width="null"
                :not="not"
                :notShow="true" 
                />  
        </v-layout> 
      </v-container>
    </v-card>
    <div class="not-fix" >
    <!-- //TOOLAR -->
    <not-toolbar 
      :not="not"
      app @navOpen="navOpen()"
      @onSignWithEmail="signWithEmail=true" 
      @navSearch="navSearch()"/>
       
    </div>

      
  </v-layout>
 
</template>

<script>
export default {
  props:["not"],
  data: () => ({
    
  }),
  computed: {
    getNot(){
      return this.$store.getters.getNotHeader
    },
    links(){
      let path = this.$route.path
      return path.split("/")
    }
  },  
  methods: {
    navOpen(){
      this.$emit("novOpen")
    },
    getLink(item){
      let index = item.index
      let name = item.name
      let path = this.$route.path
      let id = this.$route.path

      if (!index) {
        return "/"
      }
      if (index===0) {
        return "/"
      }else {
        let link = path.split(name)  
        return link[0]+name
      }
    }
  },
};
</script>
